import { Anchor, Button, PanelHeader } from '@keplerco/core';
import React from 'react';
import { IComparisonToolPanelProps } from './comparison-tool.models';

export function ComparisonToolPanel({ supertitle, title, subtitle, list, onCancel, onAdd }: Required<Omit<IComparisonToolPanelProps, 'onClose'>>): JSX.Element {
  return (
    <div className="panelContent" style={{ gap: 30 }}>
      <PanelHeader supertitle={supertitle} title={title} subtitle={subtitle} divider />

      <div>{list}</div>

      <footer className="panelFooter">
        <Anchor onClick={onCancel}>Cancel</Anchor>

        <Button type="button" onClick={onAdd}>
          Add
        </Button>
      </footer>
    </div>
  );
}
